<section class="landing">
  <div
    class="no-results"
    *ngIf="
      featuredTitles?.length === 0 &&
      upcomingTitles?.length === 0 &&
      onReleaseTitles.length === 0 &&
      recentUploadedAssetsTitles?.length === 0 &&
      showNoResults
    "
  >
    <div class="no-results__text">{{ 'no-active-titles-for-this-territory-text' | translate }}</div>
  </div>
  <div class="featured-titles" *ngIf="featuredTitles?.length > 0; else loadingFeaturedTitles">
    <swiper
      *ngIf="featuredTitles?.length > 1; else singleFeaturedTitle"
      [config]="singleItemSwiperConfig"
      #singleItemSwiper
      (activeIndexChange)="swiperSlideChanged($event)"
      [lazy]="true"
      [loop]="true"
      [navigation]="true"
      [pagination]="{ clickable: true }"
      [autoplay]="{
        delay: 10000,
        disableOnInteraction: false
      }"
    >
      <ng-template *ngFor="let featuredTitle of featuredTitles" swiperSlide>
        <div
          class="single-titles__item many-item"
          *ngIf="featuredTitle.type === 'image'"
          [style.backgroundImage]="
            'url(' + featuredTitle.previewUrl ?? featuredTitle.thumbnailUrl + ')'
          "
        ></div>
        <div class="single-titles__item" *ngIf="featuredTitle.type === 'video'">
          <vg-player class="single-titles__item--video">
            <video
              [vgHls]="featuredTitle.previewUrl"
              #sliderVideo
              id="singleVideo"
              type="video/mp4"
              [muted]="true"
              preload="auto"
              controls
              [autoplay]="true"
            ></video>
          </vg-player>
        </div>
      </ng-template>
    </swiper>
    <ng-template #singleFeaturedTitle>
      <div class="single-titles__item one-item" *ngIf="featuredTitles[0]?.type === 'image'">
        <img
          class="single-titles__item--image"
          [src]="featuredTitles[0]?.previewUrl ?? featuredTitles[0]?.thumbnailUrl"
          alt="featured title image"
        />
      </div>

      <div class="single-titles__item" *ngIf="featuredTitles[0]?.type === 'video'">
        <vg-player class="single-titles__item--video">
          <video
            [vgHls]="featuredTitles[0]?.previewUrl"
            #sliderVideo
            id="singleVideo"
            type="video/mp4"
            [muted]="true"
            preload="auto"
            controls
            [autoplay]="true"
          ></video>
        </vg-player>
      </div>
    </ng-template>
  </div>
  <ng-template #loadingFeaturedTitles>
    <div class="mx-3" [style.display]="showFT ? 'block' : 'none'">
      <ngx-skeleton-loader
        [count]="1"
        [animation]="'progress-dark'"
        [theme]="{
          height: '40vh',
          'border-radius': '10px',
          'background-color': '#101010',
          border: '1px solid #101010',
          'animation-duration': '2s'
        }"
      >
      </ngx-skeleton-loader>
    </div>
  </ng-template>

  <div
    class="upcoming-titles multiple-titles"
    *ngIf="upcomingTitles?.length > 0; else loadingUpcomingTitles"
  >
    <h1 class="multiple-titles__header">
      {{ 'upcoming-label' | translate }}
    </h1>
    <swiper
      [config]="multipleItemSwiperConfig"
      [pagination]="{ clickable: true }"
      [navigation]="true"
      [breakpoints]="{
        '640': {
          slidesPerView: 2,
          spaceBetween: 20
        },
        '768': {
          slidesPerView: 3,
          spaceBetween: 20
        },
        '992': {
          slidesPerView: 4,
          spaceBetween: 20
        },
        '1200': {
          slidesPerView: 5,
          spaceBetween: 20
        },
        '1440': {
          slidesPerView: 6,
          spaceBetween: 20
        },
        '1600': {
          slidesPerView: 7,
          spaceBetween: 20
        }
      }"
    >
      <ng-template
        *ngFor="let upcomingTitle of upcomingTitles; trackBy: trackByUpcoming"
        swiperSlide
      >
        <app-home-title [title]="upcomingTitle" [isOnRelease]="false"></app-home-title>
      </ng-template>
    </swiper>
  </div>
  <ng-template #loadingUpcomingTitles>
    <div [style.display]="showUT ? 'block' : 'none'">
      <div class="d-flex overflow-hidden mt-1 ms-2">
        <ngx-skeleton-loader
          class="loading-item"
          [count]="10"
          [animation]="'progress-dark'"
          appearance="circle"
          [theme]="{
            width: '20rem',
            height: '30rem',
            'margin-right': '2rem',
            'border-radius': '10px',
            'background-color': '#101010',
            border: '1px solid #101010',
            'animation-duration': '2s'
          }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>
  </ng-template>

  <div
  class="upcoming-titles multiple-titles"
  *ngIf="recentUploadedAssetsTitles?.length > 0; else loadingRecentUploadedAssetsTitles"
>
  <h1 class="multiple-titles__header">
    {{ 'new-assets-label' | translate }}
  </h1>
  <div class="assets_all">
    <a [routerLink]="['assets/titles']" class="link-title">{{
      'see-all-assets-label' | translate
    }}</a>
  </div>
  <swiper
    [config]="multipleItemSwiperConfig"
    [pagination]="{ clickable: true }"
    [navigation]="true"
    [breakpoints]="{
      '640': {
        slidesPerView: 2,
        spaceBetween: 20
      },
      '768': {
        slidesPerView: 3,
        spaceBetween: 20
      },
      '992': {
        slidesPerView: 4,
        spaceBetween: 20
      },
      '1200': {
        slidesPerView: 5,
        spaceBetween: 20
      },
      '1440': {
        slidesPerView: 6,
        spaceBetween: 20
      },
      '1600': {
        slidesPerView: 7,
        spaceBetween: 20
      }
    }"
  >
    <ng-template
      *ngFor="
        let recentUploadedAssetsTitle of recentUploadedAssetsTitles;
        trackBy: trackByUpcoming
      "
      swiperSlide
    >
      <app-home-title [title]="recentUploadedAssetsTitle" [isNewAssets]="true"></app-home-title>
    </ng-template>
  </swiper>
</div>
<ng-template #loadingRecentUploadedAssetsTitles>
  <div [style.display]="showNAT ? 'block' : 'none'">
    <div class="d-flex overflow-hidden mt-1 ms-2">
      <ngx-skeleton-loader
        class="loading-item"
        [count]="10"
        [animation]="'progress-dark'"
        appearance="circle"
        [theme]="{
          width: '20rem',
          height: '30rem',
          'margin-right': '2rem',
          'border-radius': '10px',
          'background-color': '#101010',
          border: '1px solid #101010',
          'animation-duration': '2s'
        }"
      >
      </ngx-skeleton-loader>
    </div>
  </div>
</ng-template>

  <div
    class="on-release-titles multiple-titles"
    *ngIf="onReleaseTitles?.length > 0; else loadingReleaseTitles"
  >
    <h1 class="multiple-titles__header">
      {{ 'on-release-label' | translate }}
    </h1>
    <swiper
      [config]="multipleItemSwiperConfig"
      [pagination]="{ clickable: true }"
      [navigation]="true"
      [breakpoints]="{
        '640': {
          slidesPerView: 2,
          spaceBetween: 20
        },
        '768': {
          slidesPerView: 3,
          spaceBetween: 20
        },
        '992': {
          slidesPerView: 4,
          spaceBetween: 20
        },
        '1200': {
          slidesPerView: 5,
          spaceBetween: 20
        },
        '1440': {
          slidesPerView: 6,
          spaceBetween: 20
        },
        '1600': {
          slidesPerView: 7,
          spaceBetween: 20
        }
      }"
    >
      <ng-template
        *ngFor="let onReleaseTitle of onReleaseTitles; trackBy: trackByOnRelease"
        swiperSlide
        ><app-home-title [title]="onReleaseTitle" [isOnRelease]="true"></app-home-title>
      </ng-template>
    </swiper>
  </div>
  <ng-template #loadingReleaseTitles>
    <div [style.display]="showRT ? 'block' : 'none'">
      <div class="d-flex overflow-hidden my-3 ms-2">
        <ngx-skeleton-loader
          class="loading-item"
          [count]="10"
          [animation]="'progress-dark'"
          appearance="circle"
          [theme]="{
            width: '20rem',
            height: '30rem',
            'margin-right': '2rem',
            'border-radius': '10px',
            'background-color': '#101010',
            border: '1px solid #101010',
            'animation-duration': '2s'
          }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>
  </ng-template>
</section>
